import styles from "./FiltersFaculty.module.scss";
import { Button, Grid } from "@mui/material";
import { Checkbox, Modal } from "antd";
import { ParamsFilterKey } from "Config/filterSearchParams";
import { FilterSelectedTags, LoadingSimpleComponent } from "Explore/Components";
import { state_select } from "Explore/Config/FilterData";
import { SkeletonType } from "Explore/Config/ImageType";
import {
  getFacetSearchAuthorInstitutions,
  getFacetSearchAuthorStates,
} from "Explore/Services/Author";
import useDeviceCheck from "Hooks/useDeviceCheck";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";

const InstitutionFacetSearchPopup = ({ open, setOpen, data, setData }) => {
  const { isMobile } = useDeviceCheck();
  const { filter, updateSearchParams } = useFilterAndPagination();
  const currentMaxPage = (Object.keys(data.data || {})?.length || 1) - 1;
  const [selected, setSelected] = useState(
    filter[ParamsFilterKey.STATES] || []
  );
  const [page, setPage] = useState(0);
  const [modalLoading, setModalLoading] = useState(data.isLoading);

  useEffect(() => {
    setPage(0);
    setSelected(filter[ParamsFilterKey.STATES] || []);
  }, [JSON.stringify(filter)]);

  const handleOk = () => {
    updateSearchParams({
      [ParamsFilterKey.STATES]: selected,
    });
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const onChangePage = (page) => {
    setPage(page);
    if (!data.data[page]) {
      setModalLoading(true);
      getFacetSearchAuthorStates({
        keywordQuery: filter[ParamsFilterKey.KEYWORD_QUERY],
        keywordTimeFilter: filter[ParamsFilterKey.KEYWORD_TIME_FILTER],
        seniority: filter[ParamsFilterKey.SENIORITIES],
        page,
        rowsPerPage: 30,
      }).then((res) => {
        setModalLoading(false);
        setData({
          data: {
            ...data.data,
            [page]: res.results,
          },
          isLoading: false,
          hasMore: res.has_next_page,
        });
      });
    }
  };

  const onChangeCheckbox = (checked, item) => {
    if (checked) {
      setSelected([...selected, item.state]);
    } else {
      setSelected(selected.filter((id) => id !== item.state));
    }
  };

  return (
    <Modal
      open={open}
      title="State Search"
      onOk={handleOk}
      width={isMobile ? "100dvw" : "80vw"}
      centered
      onCancel={handleCancel}
      onClose={handleCancel}
      okText="Apply Filter"
      classNames={{ body: styles["facet-search"] }}
    >
      <FilterSelectedTags
        filters={{
          [ParamsFilterKey.STATES]: selected,
        }}
        setFilters={(obj) => {
          setSelected(obj[ParamsFilterKey.STATES]);
        }}
      />
      <Grid container rowSpacing="12px" columnSpacing="24px">
        {(data.data[page] || []).map((item, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <LoadingSimpleComponent
              isLoading={modalLoading}
              type={SkeletonType.INPUT}
              component={
                <Checkbox
                  checked={selected.includes(item.state)}
                  onChange={(e) => onChangeCheckbox(e.target.checked, item)}
                >
                  <span className={styles["facet-search--name"]}>
                    {state_select.find((s) => s.value === item.state)?.label ||
                      item.state}
                  </span>
                  <span className={styles["facet-search--count"]}>
                    {item.no_results}
                  </span>
                </Checkbox>
              }
            />
          </Grid>
        ))}
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          marginTop: "32px",
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={() => onChangePage(page - 1)}
          startIcon={<ChevronLeft />}
          disabled={page === 0}
        >
          Prev
        </Button>

        <span>Page {page + 1}</span>

        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={() => onChangePage(page + 1)}
          endIcon={<ChevronRight />}
          disabled={page === currentMaxPage && !data.hasMore}
        >
          Next
        </Button>
      </div>
    </Modal>
  );
};

export default InstitutionFacetSearchPopup;
